import React from 'react'
import { Route, Routes } from "react-router-dom"
import ComplianceCreateScreen from "screens/App/CRM/Compliance/ComplianceCreateScreen"
import ComplianceDetailScreen from "screens/App/CRM/Compliance/ComplianceDetailScreen"
import ComplianceEditScreen from "screens/App/CRM/Compliance/ComplianceEditScreen"
import ComplianceListScreen from "screens/App/CRM/Compliance/ComplianceListScreen"
import NotFoundScreen from "screens/NotFoundScreen"

const ComplianceRouter = () => {
  return (
      <Routes>
          <Route path="create" element={<ComplianceCreateScreen />} />

          <Route path="list" element={<ComplianceListScreen />} />

          <Route path=":id/detail" element={<ComplianceDetailScreen />} />

          <Route path=":id/edit" element={<ComplianceEditScreen />} />

          <Route path="*" element={<NotFoundScreen />} />

      </Routes>
  )
}

export default ComplianceRouter